import { Div, isAdmin, TableHeader } from '@vgrubs/components';

export const DeliveriesTableHeader = () => {
  return (
    <Div $desktop>
      <TableHeader
        padding="0 20px"
        gap="12px"
        columns={[
          { label: 'Order ID', width: isAdmin ? '5%' : '7%' },
          { label: 'DSP ID', width: isAdmin ? '5%' : '7%' },
          { label: 'Pickup', width: '8%' },
          { label: 'Dropoff', width: '8%' },
          { label: 'Fleet', width: isAdmin ? '5%' : '6%' },
          { label: 'Store', width: '12%' },
          { label: 'Customer', width: '10%' },
          { label: 'Address', width: '12%' },
          { label: 'Status', width: '10%' },
          { label: 'Amount', width: isAdmin ? '12%' : '15%' },
          { label: 'Rating', width: '5%' },
          { label: 'Dispatcher', width: '8%', hidden: !isAdmin },
        ]}
      />
    </Div>
  );
};
